// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 289 ? "__federation_expose_App" : chunkId) + "." + {"289":"cf59041b47544dcb0abd","906":"50c72c0785b7b7351fc5"}[chunkId] + ".js";
};